// extracted by mini-css-extract-plugin
export var banner = "_2h-0";
export var icon = "_2h-1";
export var message = "_2h-2";